<ng-container [formGroup]="valueForm">
  <div class="d-flex align-items-center position-relative">
    @if (showLabel) {
      <label class="text-secondary" [title]="label">{{
        label
      }}</label>
    }

    <ideapa-operators
      class="ms-auto"
      [items]="operators"
      name="operator"
      formControlName="operator"
      [readOnly]="readOnly"
    ></ideapa-operators>

    @if (showClear()) {
      <span
        tabindex="0"
        class="material-symbols-outlined ms-1 text-danger cursor-pointer cancel-icon"
      [class.select-filter]="
        type === filterTypes.enum || type === filterTypes.boolean
      "
        (click)="clear(true)"
        >
        close
      </span>
    }
  </div>
  <div
    class="d-flex align-items-center"
    formArrayName="value"
    [class.dirty]="isDirty()"
    >
    @for (valueControl of valueArray.controls; track valueControl; let i = $index) {
      @if (i === 1) {
        <span>&nbsp;</span>
      }
      @if (type === filterTypes.text) {
        <ideapa-text-input
          class="flex-grow-1"
          name="value"
          [readOnly]="readOnly || false"
          [formControl]="$any(valueControl)"
          >
        </ideapa-text-input>
      }
      @if (type === filterTypes.number) {
        <ideapa-numeric-input
          class="flex-grow-1"
          name="value"
          [readOnly]="readOnly || false"
          [formControl]="$any(valueControl)"
          >
        </ideapa-numeric-input>
      }
      @if (type === filterTypes.date || type === filterTypes.datetime) {
        <ideapa-datepicker
          class="flex-grow-1"
          name="value"
          [showIcon]="false"
          [readOnly]="readOnly || false"
          [formControl]="$any(valueControl)"
          >
        </ideapa-datepicker>
      }
      @if (type === filterTypes.enum || type === filterTypes.boolean) {
        <ideapa-select
          class="flex-grow-1"
          name="value"
          [items]="items"
          [clearable]="false"
          [bindValue]="'value'"
          [formControl]="$any(valueControl)"
          [appendTo]="'body'"
          [readOnly]="readOnly || false"
          >
        </ideapa-select>
      }
      @if (type === filterTypes.autocomplete) {
        <div
          class="position-relative decode"
          >
          <input
            #decodeInput
            type="text"
            class="form-control"
            [formControl]="$any(valueControl)"
            [ngbTypeahead]="search"
            [showHint]="false"
            [editable]="false"
            [container]="'body'"
            [readOnly]="readOnly || false"
            (selectItem)="selected($event, $any(valueControl))"
            (blur)="blur(decodeInput, $any(valueControl))"
            />
          @if (autocompleteLoading) {
            <div
              class="spinner-border spinner-border-sm text-primary"
              role="status"
              >
              <span class="visually-hidden">Caricamento...</span>
            </div>
          }
        </div>
      }
    }
  </div>

  <!-- <strong>
  {{ valueForm.value | json }}
</strong> -->
</ng-container>
